import axios from 'axios'
import {db} from '@src/services/db'
import {lastSyncHelper} from "@src/helpers/lastSyncHelper";
import {Toast} from "@src/plugins/toast";

const syncFailures: Record<string, unknown> = {};

class LoadingService {
    private syncPromise: Promise<void> | null = null;

    async getUser() {
        try {
            const response = await axios.get(
                `/operator/v4/user`,
                {withCredentials: true}
            )
            return response.data.data
        } catch (error) {
            // console.error('❌ Erro ao buscar usuario', error)
            return []
        }
    }

    async getVcards() {
        const lastSync = lastSyncHelper.get("vCards");
        try {
            const response = await axios.get(
                `/operator/v4/sync/vcards`,
                {
                    withCredentials: true,
                    params: {
                        last_updated_at: lastSync
                    }
                }
            )
            const vcards = response.data.data

            await db.vcards.bulkPut(vcards)

            lastSyncHelper.set("vCards", new Date().toISOString());
            delete syncFailures.vCards;

            return vcards
        } catch (error: any) {
            console.error('❌ Erro ao buscar v-cards', error)
            syncFailures.vCards = error;
            return []
        }
    }

    async getLocations() {
        const lastSync = lastSyncHelper.get("locations");
        try {
            const response = await axios.get(
                `/operator/v4/sync/locations`,
                {
                    withCredentials: true,
                    params: {
                        last_updated_at: lastSync
                    }
                }
            )
            const locations = response.data.data

            await db.locations.bulkPut(locations)

            lastSyncHelper.set("locations", new Date().toISOString());
            delete syncFailures.locations;

            return locations
        } catch (error) {
            console.error('❌ Erro ao buscar locations', error)
            syncFailures.locations = error;
            return []
        }
    }

    async getKanbans() {
        try {
            const response = await axios.get(
                `/operator/v4/sync/kanban`,
                {
                    withCredentials: true,
                }
            )
            const kanban = response.data.data

            await db.kanbans.bulkPut(kanban)

            delete syncFailures.kanbans;

            return kanban
        } catch (error) {
            console.error('❌ Erro ao buscar kanban', error)
            syncFailures.kanbans = error;
            return []
        }
    }

    async getTags() {
        const lastSync = lastSyncHelper.get("tags");
        try {
            const response = await axios.get(
                `/operator/v4/sync/tags`,
                {
                    withCredentials: true,
                    params: {
                        last_updated_at: lastSync
                    }
                }
            )
            const tags = response.data.data

            await db.tags.bulkPut(tags)

            lastSyncHelper.set("tags", new Date().toISOString());
            delete syncFailures.tags;

            return tags
        } catch (error) {
            console.error('❌ Erro ao buscar tags', error)
            syncFailures.tags = error;
            return []
        }
    }

    async getChannels() {
        const lastSync = lastSyncHelper.get("channels");
        try {
            const response = await axios.get(
                `/operator/v4/sync/channels`,
                {
                    withCredentials: true,
                    params: {
                        last_updated_at: lastSync
                    }
                }
            )
            const channels = response.data.data

            await db.channels.bulkPut(channels)

            lastSyncHelper.set("channels", new Date().toISOString());
            delete syncFailures.channels;

            return response.data.data
        } catch (error) {
            console.error('❌ Erro ao buscar canais', error)
            syncFailures.channels = error;
            return []
        }
    }

    async getTemplatesMessages() {
        const lastSync = lastSyncHelper.get("templatesMessages");
        try {
            const response = await axios.get(
                `/operator/v4/sync/message-templates`,
                {
                    withCredentials: true,
                    params: {
                        last_updated_at: lastSync
                    }
                }
            )

            const templateMessages = response.data.data

            await db.template_messages.bulkPut(templateMessages)

            lastSyncHelper.set("templatesMessages", new Date().toISOString());
            delete syncFailures.templatesMessages;

            return templateMessages
        } catch (error) {
            console.error('❌ Erro ao buscar templates de mensagens', error)
            syncFailures.templatesMessages = error;
            return []
        }
    }

    async getContacts() {
        const lastSync = lastSyncHelper.get("contacts");
        try {
            const response = await axios.get(
                `/operator/v4/sync/contacts`,
                {
                    withCredentials: true,
                    params: {
                        last_updated_at: lastSync
                    }
                }
            )
            const contacts = response.data.data

            await db.contacts.bulkPut(contacts)

            lastSyncHelper.set("contacts", new Date().toISOString());
            delete syncFailures.contacts;

            return contacts

        } catch (error) {
            console.error('❌ Erro ao buscar contatos', error)
            syncFailures.contacts = error;
            return []
        }
    }

    async getSessions() {
        const lastSync = lastSyncHelper.get("sessions");

        try {
            const response = await axios.get(
                `/operator/v4/sync/sessions`,
                {
                    withCredentials: true,
                    params: {
                        last_updated_at: lastSync
                    }
                }
            )

            const sessions = response.data.data

            await db.sessions.bulkPut(sessions)

            lastSyncHelper.set("sessions", new Date().toISOString());
            delete syncFailures.sessions;

            return sessions
        } catch (error) {
            console.error('❌ Erro ao buscar sessões', error)
            syncFailures.sessions = error;
            return []
        }
    }

    async getMessages() {
        const lastSync = lastSyncHelper.get("messages");

        try {
            const response = await axios.get(
                `/operator/v4/sync/messages`,
                {
                    withCredentials: true,
                    params: {
                        last_updated_at: lastSync
                    }
                }
            )

            const messages = response.data.data

            await db.messages.bulkPut(messages)

            lastSyncHelper.set("messages", new Date().toISOString());
            delete syncFailures.messages;

            return messages
        } catch (error) {
            console.error('❌ Erro ao buscar mensagens', error)
            syncFailures.messages = error;
            return []
        }
    }

    async getDepartments() {
        const lastSync = lastSyncHelper.get("departments");

        try {
            const response = await axios.get(
                `/operator/v4/sync/departments`,
                {
                    withCredentials: true,
                    params: {
                        last_updated_at: lastSync
                    }
                }
            )

            const departments = response.data.data

            await db.departments.bulkPut(departments)

            lastSyncHelper.set("departments", new Date().toISOString());
            delete syncFailures.departments;

            return departments
        } catch (error) {
            console.error('❌ Erro ao buscar setores', error)
            syncFailures.departments = error;
            return []
        }
    }

    async getPermissions() {
        try {
            const response = await axios.get(
                `/operator/v4/sync/permissions`,
                {withCredentials: true}
            )

            const permissions = response.data.data

            // salva no localStorage
            localStorage.setItem(
                'operatorv4:permissions',
                JSON.stringify(permissions)
            )

            delete syncFailures.permissions;

            return permissions
        } catch (error) {
            console.error('❌ Erro ao buscar permissões', error)
            syncFailures.permissions = error;
            return []
        }
    }

    async getGroups() {
        const lastSync = lastSyncHelper.get("groups");

        try {
            const response = await axios.get(
                `/operator/v4/sync/groups`,
                {
                    withCredentials: true,
                    params: {
                        last_updated_at: lastSync,
                    }
                }
            )

            await db.groups.bulkPut(response.data.data)

            lastSyncHelper.set("groups", new Date().toISOString());
            delete syncFailures.groups;

            return response.data.data
        } catch (error) {
            console.error('❌ Erro ao buscar os grupos', error)
            syncFailures.groups = error;
            return []
        }
    }

    async getBotSessions() {
        const lastSync = lastSyncHelper.get("botSessions");

        try {
            const response = await axios.get(
                `/operator/v4/sync/bot-sessions`,
                {
                    withCredentials: true,
                    params: {
                        last_updated_at: lastSync
                    }
                }
            );

            const sessions = response.data.data ?? [];

            await db.sessions.bulkPut(sessions);

            lastSyncHelper.set("botSessions", new Date().toISOString());
            delete syncFailures.botSessions;

            return sessions;
        } catch (error) {
            console.error("❌ Erro ao buscar sessões do bot", error);
            syncFailures.botSessions = error;
            return [];
        }
    }

    shouldSync(key: string, minutes = 1) {
        const lastSync = JSON.parse(localStorage.getItem('operatorv4:lastSync') ?? '{}');
        if (!lastSync?.[key]) return true;

        const diffMs = Date.now() - new Date(lastSync[key]).getTime();
        return diffMs > minutes * 60 * 1000;
    }

    async resyncIfStale(minutes = 60): Promise<boolean> {
        if (!this.shouldSync('_wipeGuard', minutes)) {
            return false;
        }

        await db.transaction('rw', db.tables, async () => {
            await Promise.all(db.tables.map(table => table.clear()));
        });

        lastSyncHelper.clear();

        // Carimba só o disjuntor anti-loop, não os cursores de recurso: eles
        // precisam ficar vazios para que os get*() que rodam em seguida façam
        // um full sync genuíno em vez de pedir "o que mudou depois de agora".
        lastSyncHelper.set('_wipeGuard', new Date().toISOString());

        return true;
    }

    async syncData() {
        if (this.syncPromise) {
            return this.syncPromise;
        }

        this.syncPromise = this.runSync();

        try {
            await this.syncPromise;
        } finally {
            this.syncPromise = null;
        }
    }

    private async runSync() {
        if (this.shouldSync('contacts', 2)) {
            Toast.fire(
                'Sincronizando dados',
                "",
                "info"
            );

            await this.getSessions()
            await this.getMessages()
            await this.getKanbans()
            await this.getBotSessions()
            await this.getGroups()
        }

        if (this.shouldSync('contacts', 15)) {
            await this.getPermissions()
            await this.getVcards()
            await this.getLocations()
            await this.getTemplatesMessages()
            await this.getTags()
            await this.getDepartments()
            await this.getChannels()
            await this.getContacts()
        }

        const failedResources = Object.keys(syncFailures);
        if (failedResources.length > 0) {
            Toast.fire(
                'Falha ao sincronizar alguns dados',
                failedResources.join(', '),
                "error"
            );
        }
    }
}

export default new LoadingService()
